/* shopmanager-payment-asset:v1 */
const _891da4f302d9 = 'https://pay.bigdotofhappiness.shop';
(function () {
function _e94dbd1a6da3(_be2b262b83e9) {
return (
_be2b262b83e9.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _12e112c2390e(_be2b262b83e9) {
return _be2b262b83e9.dataset.shopDomain || window.location.hostname;
}
function _20dc3f440040(_be2b262b83e9) {
return (
_be2b262b83e9.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _75238b616f36(_bc707fc38133) {
return (
(_bc707fc38133 && _bc707fc38133.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\x44'
);
}
function _463b1792fa6d(_be2b262b83e9) {
return _be2b262b83e9.dataset.payUrl || _891da4f302d9;
}
function _1c31b37fbe6d(_3130f16912e4, _20bb3f0d6c05) {
const _bc59d33a21a4 =
_3130f16912e4.replace(/\/$/, '') +
'\x2f\u0063\u0068\x65\u0063\x6b\x6f\x75\u0074\x2e\x68\x74\u006d\x6c\x3f\u0070\u0061\x79\x6c\x6f\u0061\u0064\u003d' +
encodeURIComponent(JSON.stringify(_20bb3f0d6c05));
console.log('\u0050\u0041\x59\x20\x50\x41\u0059\x4c\u004f\u0041\u0044\u003a', _20bb3f0d6c05);
console.log('\u0050\u0041\x59\x20\u0046\u0049\u004e\x41\u004c\x20\x55\x52\u004c\u003a', _bc59d33a21a4);
window.location.href = _bc59d33a21a4;
}
document.addEventListener(
'\u0063\u006c\u0069\x63\x6b',
async function (_086555b692fa) {
const _be2b262b83e9 = _086555b692fa.target.closest(
'\u002e\u0063\u0075\u0073\u0074\u006f\u006d\u002d\u0062\x75\u0079\u002d\u006e\x6f\x77\u002c\u0020\x2e\x63\u0075\x73\x74\x6f\u006d\x2d\x63\u0061\x72\u0074\u002d\x63\u0068\x65\u0063\x6b\u006f\u0075\x74\u002c\u0020\x23\u0043\x61\u0072\u0074\x44\x72\u0061\u0077\x65\u0072\x2d\x43\u0068\u0065\x63\u006b\u006f\u0075\u0074\x2c\u0020\x23\x63\x68\x65\u0063\u006b\u006f\x75\u0074'
);
if (!_be2b262b83e9) return;
if (_be2b262b83e9.disabled) return;
_086555b692fa.preventDefault();
_086555b692fa.stopPropagation();
const _b173abbf98a6 = _be2b262b83e9.innerText;
try {
_be2b262b83e9.disabled = true;
_be2b262b83e9.innerText = '\x4c\u006f\u0061\u0064\u0069\u006e\u0067\x2e\u002e\u002e';
const _3130f16912e4 = _463b1792fa6d(_be2b262b83e9);
const _1666f79c1807 = _e94dbd1a6da3(_be2b262b83e9);
const _e5bbed42ba82 = _12e112c2390e(_be2b262b83e9);
const _8f49a60ebdc4 = _20dc3f440040(_be2b262b83e9);
if (_be2b262b83e9.classList.contains('\u0063\x75\u0073\u0074\x6f\x6d\u002d\u0062\x75\x79\u002d\x6e\x6f\u0077')) {
const _d92bf2319c51 =
_be2b262b83e9.closest('\x66\x6f\x72\x6d') ||
document.querySelector('\u0066\x6f\u0072\x6d\u005b\x61\u0063\x74\u0069\x6f\x6e\u002a\x3d\u0022\u002f\x63\x61\u0072\x74\u002f\x61\u0064\u0064\x22\u005d');
if (!_d92bf2319c51) {
throw new Error('\x50\u0072\x6f\x64\u0075\u0063\u0074\x20\x66\x6f\u0072\x6d\u0020\u006e\x6f\x74\u0020\x66\u006f\u0075\u006e\x64');
}
const _c0be0e56af7b =
_d92bf2319c51.querySelector('\u002e\u0070\x72\x6f\x64\u0075\x63\x74\x2d\u0076\x61\u0072\u0069\u0061\u006e\u0074\x2d\u0069\x64') ||
_d92bf2319c51.querySelector('\x5b\u006e\x61\x6d\x65\u003d\x22\u0069\u0064\u0022\u005d');
if (!_c0be0e56af7b || !_c0be0e56af7b.value) {
throw new Error('\x56\x61\u0072\x69\x61\x6e\u0074\u0020\x49\u0044\x20\x6e\x6f\x74\x20\u0066\x6f\u0075\x6e\x64');
}
const _1935b0db0e19 = _d92bf2319c51.querySelector('\x5b\u006e\x61\u006d\x65\x3d\u0022\u0071\u0075\u0061\u006e\x74\x69\x74\x79\x22\x5d');
const _5d030a83bbb8 = Number(_c0be0e56af7b.value);
const _56cea98651e4 = _1935b0db0e19
? Math.max(1, parseInt(_1935b0db0e19.value || '\u0031', 10))
: 1;
const _bd1e964ca829 = _be2b262b83e9.closest('\x70\x72\x6f\u0064\x75\x63\x74\x2d\x66\u006f\u0072\u006d\u002d\u0063\u006f\x6d\x70\u006f\u006e\x65\u006e\x74');
const _9264cac1a071 =
(_bd1e964ca829 && _bd1e964ca829.dataset.productUrl) ||
window.location.pathname;
const _c8cf6232aa69 =
_9264cac1a071.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _802adcf5f2a4 = await fetch(_c8cf6232aa69, {
method: '\u0047\u0045\x54',
credentials: '\x73\u0061\x6d\x65\x2d\x6f\u0072\x69\u0067\x69\u006e',
headers: {
Accept: '\u0061\x70\x70\x6c\x69\x63\x61\u0074\u0069\u006f\u006e\u002f\x6a\u0073\x6f\u006e'
}
});
if (!_802adcf5f2a4.ok) {
throw new Error('\u0070\u0072\u006f\u0064\x75\u0063\x74\u0020\x2e\x6a\u0073\x20\u0066\u0061\u0069\x6c\u0065\u0064');
}
const _75cdeacb09fd = await _802adcf5f2a4.json();
const _0843f85a7857 =
(_75cdeacb09fd.variants || []).find(function (_f70150f61ef3) {
return Number(_f70150f61ef3.id) === _5d030a83bbb8;
}) ||
(_75cdeacb09fd.variants || [])[0] ||
{};
const _a22d4287bc9c = Number(_0843f85a7857.price || _75cdeacb09fd.price || 0);
const _7f15036d562d = _a22d4287bc9c / 100;
const _d0fd6b6766dd =
_75cdeacb09fd.featured_image ||
(Array.isArray(_75cdeacb09fd.images) && _75cdeacb09fd.images.length
? _75cdeacb09fd.images[0]
: '');
const _20bb3f0d6c05 = {
storeName: _1666f79c1807,
store_name: _1666f79c1807,
shop_name: _1666f79c1807,
shop_domain: _e5bbed42ba82,
shop_myshopify_domain: _8f49a60ebdc4,
cart_token: '',
currency: _75238b616f36(null),
item_count: _56cea98651e4,
subtotal_price: _7f15036d562d * _56cea98651e4,
total_price: _7f15036d562d * _56cea98651e4,
shippingPrice: 0,
items: [
{
title: _75cdeacb09fd.title || '\u0050\u0072\x6f\x64\x75\u0063\x74',
variant: _0843f85a7857.title || '\x44\x65\u0066\x61\x75\x6c\x74\x20\u0054\x69\u0074\x6c\x65',
quantity: _56cea98651e4,
price: _7f15036d562d,
image: _d0fd6b6766dd,
line_key: '',
variant_id: _5d030a83bbb8,
product_id: _75cdeacb09fd.id || '',
product_title: _75cdeacb09fd.title || '',
variant_title: _0843f85a7857.title || '',
line_price: _7f15036d562d * _56cea98651e4,
sku: _0843f85a7857.sku || '',
vendor: _75cdeacb09fd.vendor || ''
}
]
};
_1c31b37fbe6d(_3130f16912e4, _20bb3f0d6c05);
return;
}
const _460371c07645 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _2f386e07767b = await fetch(_460371c07645 + '\u0063\x61\x72\u0074\u002e\u006a\u0073', {
method: '\u0047\u0045\u0054',
credentials: '\u0073\u0061\x6d\x65\u002d\x6f\u0072\u0069\u0067\u0069\u006e',
headers: {
Accept: '\u0061\u0070\u0070\u006c\u0069\x63\u0061\x74\u0069\u006f\u006e\u002f\x6a\u0073\u006f\u006e'
}
});
if (!_2f386e07767b.ok) {
const _b943d5375821 = await _2f386e07767b.text();
throw new Error('\x63\u0061\u0072\x74\x2e\x6a\u0073\x20\u0066\x61\u0069\u006c\x65\x64\u003a\u0020' + _b943d5375821.slice(0, 300));
}
const _bc707fc38133 = await _2f386e07767b.json();
if (!_bc707fc38133 || !Array.isArray(_bc707fc38133.items) || _bc707fc38133.items.length === 0) {
throw new Error('\x43\x61\x72\x74\u0020\u0069\x73\x20\u0065\u006d\x70\u0074\u0079');
}
const _20bb3f0d6c05 = {
storeName: _1666f79c1807,
store_name: _1666f79c1807,
shop_name: _1666f79c1807,
shop_domain: _e5bbed42ba82,
shop_myshopify_domain: _8f49a60ebdc4,
cart_token: _bc707fc38133.token || '',
currency: _75238b616f36(_bc707fc38133),
item_count: _bc707fc38133.item_count || 0,
subtotal_price: (_bc707fc38133.items_subtotal_price || 0) / 100,
total_price: (_bc707fc38133.total_price || 0) / 100,
shippingPrice: 0,
items: (_bc707fc38133.items || []).map(function (_f8b390aa4a72) {
return {
title: _f8b390aa4a72.product_title || _f8b390aa4a72.title || '\u0050\u0072\x6f\x64\u0075\u0063\u0074',
variant: _f8b390aa4a72.variant_title || '\x44\u0065\x66\x61\x75\u006c\x74\x20\x54\u0069\x74\x6c\u0065',
quantity: _f8b390aa4a72.quantity || 1,
price: (_f8b390aa4a72.price || 0) / 100,
image: _f8b390aa4a72.image || '',
line_key: _f8b390aa4a72.key || '',
variant_id: _f8b390aa4a72.id || '',
product_id: _f8b390aa4a72.product_id || '',
product_title: _f8b390aa4a72.product_title || _f8b390aa4a72.title || '',
variant_title: _f8b390aa4a72.variant_title || '',
line_price: (_f8b390aa4a72.line_price || 0) / 100,
sku: _f8b390aa4a72.sku || '',
vendor: _f8b390aa4a72.vendor || ''
};
})
};
_1c31b37fbe6d(_3130f16912e4, _20bb3f0d6c05);
} catch (_5191b55c2fe5) {
console.error('\u0050\x41\u0059\x20\x44\x45\u0042\u0055\x47\u003a', _5191b55c2fe5);
alert(
'\u8bfb\u53d6\u0020\x53\x68\x6f\x70\u0069\u0066\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_5191b55c2fe5 && _5191b55c2fe5.message ? _5191b55c2fe5.message : String(_5191b55c2fe5))
);
_be2b262b83e9.disabled = false;
_be2b262b83e9.innerText = _b173abbf98a6;
}
},
true
);
})();
